import React, { useState, useEffect } from 'react';
import { getCompanySettings } from './api';
import './PrintQuote.css';
import { formatDateDisplay, formatDateTimeDisplay } from '../utils/timezone';

const PrintQuote = ({ quote }) => {
  const [companySettings, setCompanySettings] = useState({
    company_name: 'Paragon Wheel Repair',
    company_address: '123 Main Street',
    company_city: 'Your City, ST 12345',
    company_phone: '(555) 123-4567',
    company_email: 'info@paragonwheelrepair.com',
    company_logo_url: '',
    payment_terms: 'This quote is valid for 30 days from the date issued.',
    invoice_footer_text: 'Thank you for considering our services!',
    invoice_contact_text: 'Questions? Contact us at (555) 123-4567 or email info@paragonwheelrepair.com',
  });

  const [quoteNotes, setQuoteNotes] = useState('');

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const settings = await getCompanySettings();
        setCompanySettings(settings);
      } catch (error) {
        console.error('Error fetching company settings:', error);
        // Keep default settings if fetch fails
      }
    };
    fetchSettings();
  }, []);

  if (!quote) return null;

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return formatDateDisplay(dateString);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount || 0);
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return '';
    return formatDateTimeDisplay(dateString);
  };

  return (
    <div className="print-quote">
      <div className="quote-header">
        <div className="company-address">
          <p>{companySettings.company_address}</p>
          <p>{companySettings.company_city}</p>
          <p>Phone: {companySettings.company_phone}</p>
        </div>
        
        <div className="company-logo-center">
          {companySettings.company_logo_url && (
            <img 
              src={companySettings.company_logo_url} 
              alt="Company Logo" 
              className="company-logo"
            />
          )}
        </div>
      </div>

      <div className="quote-info-section">
        <div className="quote-info-right">
          <div className="quote-info-item">
            <span className="label">QUOTE #</span>
            <span className="value">{quote.id}</span>
          </div>
          <div className="quote-info-item">
            <span className="label">DATE</span>
            <span className="value">{formatDate(quote.created_at)}</span>
          </div>
          <div className="quote-info-item">
            <span className="label">EXPIRES</span>
            <span className="value">{formatDate(quote.expiration_date)}</span>
          </div>
        </div>
      </div>

      <div className="bottom-blue-line"></div>

      <div className="bill-to-section">
        <div className="bill-to">
          <h3>Quote For:</h3>
          <div className="customer-info">
            <p><strong>{quote.customer_name || quote.customer_details?.name}</strong></p>
          </div>
        </div>
      </div>

      <div className="services-section">
        <table className="services-table">
          <thead>
            <tr>
              <th>Service Description</th>
              <th>Qty</th>
              <th>Rate</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="service-description">
                  <p><strong>{quote.service_requested}</strong></p>
                  {quote.vehicle && <p>Vehicle: {quote.vehicle}</p>}
                  {quote.straightening && quote.straightening !== 'None' && (
                    <p>Straightening: {quote.straightening}</p>
                  )}
                </div>
              </td>
              <td>{quote.number_of_wheels || 1}</td>
              <td>{formatCurrency(quote.price)}</td>
              <td>{formatCurrency(quote.price)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="totals-section">
        <div className="totals-table">
          <div className="total-row total-final">
            <span className="label"><strong>Quote Total:</strong></span>
            <span className="value"><strong>{formatCurrency(quote.price)}</strong></span>
          </div>
        </div>
      </div>


      <div className="notes-section">
        <h3>Notes</h3>
        <textarea
          value={quoteNotes}
          onChange={(e) => setQuoteNotes(e.target.value)}
          className="notes-textarea"
          placeholder="Add any additional notes for this quote..."
        />
      </div>

      <div className="footer-section">
        <div className="contact-info">
          <p>{companySettings.invoice_contact_text}</p>
        </div>
      </div>
    </div>
  );
};

export default PrintQuote;
